const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');
const menuIconURI = "data:image/png;base64,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"

class PythonTypeConversionExtension {
    constructor(runtime) {
        this.runtime = runtime;
    }

    getInfo() {
        return {
            id: "pythonTypeConversion",
            color1: '#9a32cd',
            name: "Python Type Conversion",
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: "to_string",
                    blockType: BlockType.REPORTER,
                    text: "str([VALUE])",
                    arguments: {
                        VALUE: {
                            type: ArgumentType.STRING,
                            defaultValue: '"String"'
                        }
                    }
                },
                {
                    opcode: "string_to_int",
                    blockType: BlockType.REPORTER,
                    text: "int([STRING])",
                    arguments: {
                        STRING: {
                            type: ArgumentType.STRING,
                            defaultValue: "123"
                        }
                    }
                },
                {
                    opcode: "string_to_float",
                    blockType: BlockType.REPORTER,
                    text: "float([STRING])",
                    arguments: {
                        STRING: {
                            type: ArgumentType.STRING,
                            defaultValue: "123.45"
                        }
                    }
                },
                {
                    opcode: "string_to_boolean",
                    blockType: BlockType.REPORTER,
                    text: "bool([STRING])",
                    arguments: {
                        STRING: {
                            type: ArgumentType.STRING,
                            defaultValue: "true"
                        }
                    }
                }
            ]
        };
    }

    to_string(args) {
      let val = this.convertToString(args.VALUE);

      // If it's already wrapped in quotes, strip them first
      if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
          val = val.slice(1, -1);
      }

      // Always wrap once in double quotes
      return `"${val}"`;
    }

    string_to_int(args) {
        // Python's int() trims whitespace, parses numbers, and errors on invalid input
        // We'll return 0 for invalid input (Python would raise ValueError)
        let value = args.STRING;
        if (typeof value === 'boolean') return value ? 1 : 0;
        if (typeof value === 'number') return Math.trunc(value);
        if (typeof value === 'object' && value !== null) return 0;
        let str = String(value).trim();
        // Remove quotes if present
        if ((str.startsWith('"') && str.endsWith('"')) || (str.startsWith("'") && str.endsWith("'"))) {
            str = str.slice(1, -1);
        }
        const n = parseInt(str, 10);
        return isNaN(n) ? 0 : n;
    }

    string_to_float(args) {
      let value = args.STRING;

      // Handle booleans
      if (typeof value === "boolean") return value ? "1.0" : "0.0";

      // Handle numbers directly
      if (typeof value === "number") return value.toFixed(1);

      // Handle null / objects (safe fallback)
      if (value === null || typeof value === "object") return "0.0";

      // Convert to string and trim
      let str = String(value).trim();

      // Remove wrapping quotes
      if ((str.startsWith('"') && str.endsWith('"')) || (str.startsWith("'") && str.endsWith("'"))) {
          str = str.slice(1, -1);
      }

      // Parse float
      let n = parseFloat(str);

      if (isNaN(n)) return "0.0";

      // Return formatted as string with 1 decimals
      return n.toFixed(1);
    }

    string_to_boolean(args) {
         // Python's bool() returns False for '', '0', 0, 0.0, None, False; True otherwise
        let value = args.STRING;
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number') return value !== 0;
        if (value === null || value === undefined) return false;
        if (typeof value === 'object') return true;
        let str = String(value).trim().toLowerCase();
        // Remove quotes if present
        if ((str.startsWith('"') && str.endsWith('"')) || (str.startsWith("'") && str.endsWith("'"))) {
            str = str.slice(1, -1).trim().toLowerCase();
        }
        if (str === '' || str === '0' || str === 'false' || str === 'none' || str === 'null' || str === 'undefined') {
            return false;
        }
        return true;
    }

    convertToString(value) {
         // Python's str() for objects is their string representation
        if (value === null) return 'None';
        if (typeof value === 'undefined') return 'None';
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value);
            } catch (e) {
                return String(value);
            }
        }
        return String(value);
    }
}

module.exports = PythonTypeConversionExtension;